import { useAppDisplayModeContext } from '@archipro-design/aria';
import { ArticleCarouselPlaceholderMobile } from './ArticleCarouselPlaceholder.mobile';

interface ArticleCarouselPlaceholderProps {
    title: string;
}

//Move article placeholder into generic component
//for use with mobile and desktop
const ArticleCarouselPlaceholder = ({
    title,
}: ArticleCarouselPlaceholderProps) => {
    const { mobile: isMobile } = useAppDisplayModeContext();

    return (
        <>
            {isMobile ? (
                <ArticleCarouselPlaceholderMobile title={title} />
            ) : (
                <ArticleCarouselPlaceholderMobile title={title} />
            )}
        </>
    );
};

export default ArticleCarouselPlaceholder;
